import { render, staticRenderFns } from "./VersionBanner.vue?vue&type=template&id=2e34c3fd&scoped=true"
import script from "./VersionBanner.vue?vue&type=script&lang=js"
export * from "./VersionBanner.vue?vue&type=script&lang=js"
import style0 from "./VersionBanner.vue?vue&type=style&index=0&id=2e34c3fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e34c3fd",
  null
  
)

export default component.exports